import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { IOException3fje1ukjwthwb as IOException } from '../../../../../okio-parent-okio/okio/NonJvmPlatform.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { RuntimeException1r3t0zl97011n as RuntimeException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { firstOrNull1982767dljvdy as firstOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ApolloNetworkExceptionClass;
function ApolloNetworkException() {
  if (ApolloNetworkExceptionClass === VOID) {
    class $ extends ApolloException() {
      static d47(message, platformCause) {
        message = message === VOID ? null : message;
        platformCause = platformCause === VOID ? null : platformCause;
        var $this = this.o4c(message, platformCause instanceof Error ? platformCause : null);
        captureStack($this, $this.c47_1);
        $this.b47_1 = platformCause;
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloNetworkException', $.d47);
    ApolloNetworkExceptionClass = $;
  }
  return ApolloNetworkExceptionClass;
}
var OfflineExceptionClass;
function OfflineException() {
  if (OfflineExceptionClass === VOID) {
    class $ extends IOException() {
      static s4c() {
        OfflineException_instance = null;
        var $this = this.c3z('The device is offline');
        OfflineException_instance = $this;
        captureStack($this, $this.r4c_1);
        return $this;
      }
      toString() {
        return 'OfflineException';
      }
      hashCode() {
        return -155984151;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof OfflineException()))
          return false;
        other instanceof OfflineException() || THROW_CCE();
        return true;
      }
    }
    initMetadataForObject($, 'OfflineException');
    OfflineExceptionClass = $;
  }
  return OfflineExceptionClass;
}
var OfflineException_instance;
function OfflineException_getInstance() {
  if (OfflineException_instance === VOID)
    OfflineException().s4c();
  return OfflineException_instance;
}
var ApolloExceptionClass;
function ApolloException() {
  if (ApolloExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static o4c(message, cause) {
        message = message === VOID ? null : message;
        cause = cause === VOID ? null : cause;
        var $this = this.wd(message, cause);
        captureStack($this, $this.n4c_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloException');
    ApolloExceptionClass = $;
  }
  return ApolloExceptionClass;
}
var JsonDataExceptionClass;
function JsonDataException() {
  if (JsonDataExceptionClass === VOID) {
    class $ extends ApolloException() {
      static x46(message) {
        var $this = this.o4c(message);
        captureStack($this, $this.w46_1);
        return $this;
      }
    }
    initMetadataForClass($, 'JsonDataException');
    JsonDataExceptionClass = $;
  }
  return JsonDataExceptionClass;
}
var DefaultApolloExceptionClass;
function DefaultApolloException() {
  if (DefaultApolloExceptionClass === VOID) {
    class $ extends ApolloException() {
      static m44(message, cause) {
        message = message === VOID ? null : message;
        cause = cause === VOID ? null : cause;
        var $this = this.o4c(message, cause);
        captureStack($this, $this.l44_1);
        return $this;
      }
    }
    initMetadataForClass($, 'DefaultApolloException', $.m44);
    DefaultApolloExceptionClass = $;
  }
  return DefaultApolloExceptionClass;
}
var ApolloHttpExceptionClass;
function ApolloHttpException() {
  if (ApolloHttpExceptionClass === VOID) {
    class $ extends ApolloException() {
      static a4d(statusCode, headers, body, message, cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.o4c(message, cause);
        captureStack($this, $this.z4c_1);
        $this.w4c_1 = statusCode;
        $this.x4c_1 = headers;
        $this.y4c_1 = body;
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloHttpException');
    ApolloHttpExceptionClass = $;
  }
  return ApolloHttpExceptionClass;
}
var RouterErrorClass;
function RouterError() {
  if (RouterErrorClass === VOID) {
    class $ extends ApolloException() {
      static g4d(errors) {
        var tmp0_safe_receiver = firstOrNull(errors);
        var $this = this.o4c("Router error(s) (first: '" + (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i46_1) + "')");
        captureStack($this, $this.f4d_1);
        $this.e4d_1 = errors;
        return $this;
      }
    }
    initMetadataForClass($, 'RouterError');
    RouterErrorClass = $;
  }
  return RouterErrorClass;
}
var SubscriptionOperationExceptionClass;
function SubscriptionOperationException() {
  if (SubscriptionOperationExceptionClass === VOID) {
    class $ extends ApolloException() {
      static m4d(operationName, payload) {
        var $this = this.o4c('Operation error ' + operationName);
        captureStack($this, $this.l4d_1);
        $this.k4d_1 = payload;
        return $this;
      }
    }
    initMetadataForClass($, 'SubscriptionOperationException');
    SubscriptionOperationExceptionClass = $;
  }
  return SubscriptionOperationExceptionClass;
}
var ApolloGraphQLExceptionClass;
function ApolloGraphQLException() {
  if (ApolloGraphQLExceptionClass === VOID) {
    class $ extends ApolloException() {
      static t44(error) {
        var $this = this.o4c("GraphQL error: '" + error.i46_1 + "'");
        captureStack($this, $this.s44_1);
        $this.q44_1 = error;
        $this.r44_1 = listOf($this.q44_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloGraphQLException');
    ApolloGraphQLExceptionClass = $;
  }
  return ApolloGraphQLExceptionClass;
}
var NullOrMissingFieldClass;
function NullOrMissingField() {
  if (NullOrMissingFieldClass === VOID) {
    class $ extends ApolloException() {
      static e45(message) {
        var $this = this.o4c(message);
        captureStack($this, $this.d45_1);
        return $this;
      }
    }
    initMetadataForClass($, 'NullOrMissingField');
    NullOrMissingFieldClass = $;
  }
  return NullOrMissingFieldClass;
}
var NoDataExceptionClass;
function NoDataException() {
  if (NoDataExceptionClass === VOID) {
    class $ extends ApolloException() {
      static z44(cause) {
        var $this = this.o4c('No data was found', cause);
        captureStack($this, $this.y44_1);
        return $this;
      }
    }
    initMetadataForClass($, 'NoDataException');
    NoDataExceptionClass = $;
  }
  return NoDataExceptionClass;
}
var JsonEncodingExceptionClass;
function JsonEncodingException() {
  if (JsonEncodingExceptionClass === VOID) {
    class $ extends ApolloException() {
      static e4c(message) {
        var $this = this.o4c(message);
        captureStack($this, $this.d4c_1);
        return $this;
      }
    }
    initMetadataForClass($, 'JsonEncodingException');
    JsonEncodingExceptionClass = $;
  }
  return JsonEncodingExceptionClass;
}
var ApolloWebSocketClosedExceptionClass;
function ApolloWebSocketClosedException() {
  if (ApolloWebSocketClosedExceptionClass === VOID) {
    class $ extends ApolloException() {
      static t4d(code, reason, cause) {
        reason = reason === VOID ? null : reason;
        cause = cause === VOID ? null : cause;
        var $this = this.o4c("WebSocket Closed code='" + code + "' reason='" + reason + "'", cause);
        captureStack($this, $this.s4d_1);
        $this.q4d_1 = code;
        $this.r4d_1 = reason;
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloWebSocketClosedException');
    ApolloWebSocketClosedExceptionClass = $;
  }
  return ApolloWebSocketClosedExceptionClass;
}
//region block: exports
export {
  ApolloException as ApolloException16lek20l78zc3,
  ApolloGraphQLException as ApolloGraphQLException2qazyzs4ebcad,
  ApolloHttpException as ApolloHttpException3o30u8ntkffuh,
  ApolloNetworkException as ApolloNetworkException3denf70pfh242,
  ApolloWebSocketClosedException as ApolloWebSocketClosedException26hvn543pf46i,
  DefaultApolloException as DefaultApolloException8w3ielfxng0h,
  JsonDataException as JsonDataException2rdtm884tky1l,
  JsonEncodingException as JsonEncodingException1gbe1fu68vssf,
  NoDataException as NoDataException34qvcinicy2ih,
  NullOrMissingField as NullOrMissingField1bkks6typ2v8h,
  RouterError as RouterError3i6hxcnqsy5l3,
  SubscriptionOperationException as SubscriptionOperationException3t8cqqpx8bt9j,
  OfflineException_getInstance as OfflineException_getInstance26hqn5ntn4qci,
};
//endregion

//# sourceMappingURL=Exceptions.mjs.map
